import React, { useLayoutEffect, useState } from 'react';
import './editCss.scss';
import EditCssModal from './EditCssModal';
import { getElementAbsoluteCoords } from './cssUtils';
import OutlineButton from '../inputs/OutlineButton/OutlineButton';
import { editCssMenu } from './editCssConfig';
const EditSingleElement = ({
  id,
  menuType = '',
  setCss,
  htmlElement,
  allElements = [],
  currentCustomCss
}) => {
  const element = document.querySelector(`[data-custom-css-id=${id}]`);
  const [showHover, setShowHover] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const positionAttribute = htmlElement.getAttribute('data-custom-css-position');
  const generateElementPosition = () => {
    return {
      top: `${top - 19 + height / 2}px`,
      left: positionAttribute && positionAttribute === 'right' ? `${left + width + 19}px` : `${left - 19 + width / 2}px`
    };
  };
  useLayoutEffect(() => {
    if (element) {
      element.addEventListener('mouseover', e => {
        setShowHover(true);
      });
      element.addEventListener('mouseleave', e => {
        setShowHover(false);
      });
    }
  }, [element]);
  const setElementCss = cssObject => {
    setCss(cssObject);
    setShowMenu(false);
  };
  const {
    left,
    top,
    width,
    height
  } = getElementAbsoluteCoords(element);
  const whiteButtonMode = editCssMenu[menuType] && editCssMenu[menuType].whiteButton;
  return (showHover || true) && element ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hover-menu",
    style: generateElementPosition()
  }, /*#__PURE__*/React.createElement(OutlineButton, {
    icon: whiteButtonMode ? 'white-pencil' : 'green-pencil',
    white: whiteButtonMode ? true : false,
    onClick: () => {
      setShowMenu(true);
    }
  })), showMenu && /*#__PURE__*/React.createElement(EditCssModal, {
    id: id,
    element: element,
    show: showMenu,
    setShow: setShowMenu,
    menuType: menuType,
    setElementCss: setElementCss,
    htmlElement: htmlElement,
    allElements: allElements,
    currentCustomCss: currentCustomCss
  })) : '';
};
export default EditSingleElement;